import {
  Container,
  ContainerFilter,
  ContainerOptions,
  ContainerReports,
} from './styles';
import { Button, Space } from 'antd';
import {
  CalendarOutlined,
  LeftCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import type { MenuProps } from 'antd';
import { AButton, AInput, DropdownOptions } from '..';
import { ASelect } from '..';

interface IContainerOptionsProps {
  menu_items: MenuProps['items'];
  showInputSearch?: boolean;
  search?: string;
  setSearch?: any;
  showFilter?: boolean;
  status?: number | null | undefined;
  setStatus?: any;
  type?: number | null | undefined;
  setType?: any;
  date_initial?: string | null;
  setDate_initial?: any;
  date_final?: string | null;
  setDate_final?: any;
  filter_by?: string | null;
  setFilter_by?: any;
  showButtonBack?: boolean;
  onClickButtonSearch?: any;
  hideMenuButton?: boolean;
  report_items?: MenuProps['items'];
}

export const MenuOptions: React.FC<IContainerOptionsProps> = ({
  menu_items,
  showInputSearch = false,
  search,
  setSearch,
  showFilter = false,
  status,
  setStatus,
  type,
  setType,
  date_initial,
  setDate_initial,
  date_final,
  setDate_final,
  filter_by,
  setFilter_by,
  showButtonBack,
  onClickButtonSearch,
  hideMenuButton = false,
  report_items = [],
}) => {
  const navigate = useNavigate();
  return (
    <Container $showInputSearch={showInputSearch}>
      {showInputSearch && (
        <AInput
          placeholder="Pesquisar..."
          prefix={<SearchOutlined />}
          value={search || ''}
          onChange={(e) => setSearch(e.target.value)}
          style={{ minWidth: 260 }}
        />
      )}
      {showFilter && (
        <ContainerFilter>
          <ASelect
            placeholder="Status"
            value={status}
            onChange={(e) => setStatus(e)}
            style={{ width: 130 }}
            allowClear
            options={[
              { label: 'Aberto', value: 1 },
              { label: 'Pago', value: 2 },
              { label: 'Aberto / Pago', value: 3 },
              { label: 'Cancelado', value: 5 },
            ]}
          />

          {!hideMenuButton && (
            <ASelect
              placeholder="Tipo"
              value={type}
              onChange={(e) => setType(e)}
              style={{ width: 110 }}
              allowClear
              options={[
                { label: 'Receita', value: 1 },
                { label: 'Despesa', value: 0 },
              ]}
            />
          )}

          <AInput
            type="date"
            prefix={<CalendarOutlined />}
            value={date_initial || ''}
            onChange={(e) => setDate_initial(e.target.value)}
          />

          <AInput
            type="date"
            prefix={<CalendarOutlined />}
            value={date_final || ''}
            onChange={(e) => setDate_final(e.target.value)}
          />

          <ASelect
            placeholder="Filtrar por"
            value={filter_by}
            onChange={(e) => setFilter_by(e)}
            style={{ width: 170 }}
            allowClear
            options={[
              { label: 'Lançamento', value: 'issue_date' },
              { label: 'Vencimento', value: 'due_date' },
              { label: 'Pagamento', value: 'payment_date' },
            ]}
          />
          <AButton
            type="primary"
            style={{ marginTop: -5 }}
            icon={<SearchOutlined />}
            onClick={onClickButtonSearch}
          >
            Buscar
          </AButton>
        </ContainerFilter>
      )}
      <ContainerOptions>
        {showButtonBack && (
          <Button onClick={() => navigate(-1)} style={{ marginRight: 4 }}>
            <Space>
              <LeftCircleOutlined />
              Voltar
            </Space>
          </Button>
        )}
        {!hideMenuButton && (
          <DropdownOptions name="Opções" size="middle" items={menu_items} />
        )}
        {report_items.length > 0 && (
          <ContainerReports>
            <DropdownOptions
              name="Relatórios"
              size="middle"
              items={report_items}
            />
          </ContainerReports>
        )}
      </ContainerOptions>
    </Container>
  );
};
